import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Spinner, Card, Row, Col } from "react-bootstrap";
import { FaInfoCircle } from "react-icons/fa";
import { companyID, employeeDetails } from "../../auth";
import { applyResignation } from "../../services/ResignationServices";
import { calculateResignationDates } from "../../utils/calculateResignationDates";
import api from "../../api/axios";
import Swal from "sweetalert2";
import { formatDateForSQL } from "../../utils/formatDateForSQL";

const ResignationModal = ({ show, onHide, employeeId }) => {
  const employeeEmploymentDetails = employeeDetails();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [resignationPolicyDetails, setResignationPolicyDetails] = useState({});
  const [resignationDetails, setResignationDetails] = useState({
    reason_of_resignation: "",
    resignation_date: formatDateForSQL(new Date()),
    employment_status: "",
  });
  const [error, setError] = useState({ reason: "" });

  const company_id = companyID();

  const resetValues = () => {
    setResignationDetails({
      reason_of_resignation: "",
      resignation_date: formatDateForSQL(new Date()),
      employment_status: "",
    });
    setError({ reason: "" });
  };

  const fetchResignationPolicyData = (id , employment_status , department_id) => {
    api
      .get(`resignation-policies?company_id=${id}&employment_status=${employment_status}&department_id=${department_id}`)
      .then((res) => {
        console.log("res" , res);
        setResignationPolicyDetails(res?.data?.result[0]);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    if (employeeEmploymentDetails) {
      setResignationDetails((prev) => ({
        ...prev,
        employment_status: employeeEmploymentDetails?.employment_status,
      }));
    }
    if (company_id) {
      fetchResignationPolicyData(company_id , employeeEmploymentDetails?.employment_status, employeeEmploymentDetails?.department_id
 );
    }
  }, []);

  const { notice_period_days, salary_hold_type_id } =
    resignationPolicyDetails || {};

  const { resignation_date, reason_of_resignation } = resignationDetails || {};

  const onChangeReason = (e) => {
    setResignationDetails((prev) => ({
      ...prev,
      reason_of_resignation: e.target.value,
    }));
    setError({
      reason: "",
    });
  };

  const validateReason = () => {
    const reason = resignationDetails.reason_of_resignation.trim();
    const wordCount = reason.split(/\s+/).length;
    if (!reason || wordCount < 40) {
      setError({
        reason: "Please enter reason of separation, at least 50 words",
      });
      setIsSubmitting(false);
      return true;
    } else {
      setError({
        reason: "",
      });
      return false;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    if (validateReason()) {
      return;
    }
    try {
      console.log("resignationPolicyDetails" , resignationPolicyDetails , resignationDetails)
      const resignationDates = await calculateResignationDates(
        resignationPolicyDetails,
        resignationDetails
      );

      const {
        last_working_date,
        salary_release_date,
        asset_return_due_date,
        pending_amount_release_date,
        document_release_date,
      } = resignationDates || {};

      const employeeResignation = {
        employee_id: employeeId,
        notice_period_days:
          employeeEmploymentDetails?.employment_status === "permanent"
            ? notice_period_days
            : 0,
        resignation_date,
        last_working_date,
        salary_hold_type_id,
        salary_release_date,
        asset_return_status: "Pending",
        asset_return_due_date,
        pending_amount_release_date,
        document_release_date,
        reason_of_resignation,
      };

      const response = await applyResignation(employeeResignation);
      onHide();
      Swal.fire({
        title: "Separation",
        text: response?.message,
        icon: "success",
        confirmButtonText: "OK",
        timer: 2000,
        timerProgressBar: true,
        customClass: {
          confirmButton: "btn btn-primary",
        },
      });
    } catch (error) {
      console.error(error);
      onHide();
      Swal.fire({
        title: "Separation",
        text: "Something went wrong, please try again later",
        icon: "warning",
        confirmButtonText: "OK",
        timer: 2000,
        timerProgressBar: true,
        customClass: {
          confirmButton: "btn btn-primary",
        },
      });
    } finally {
      resetValues();
      setIsSubmitting(false);
    }
  };

  return (
    <Modal show={show} centered size="lg">
      <Modal.Header>
        <Modal.Title>Apply for Separation</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* Resignation Details Section */}
        {/* <Card className="mb-4">
          <Card.Body>
            <Card.Title>Separation Policy Details</Card.Title>
            <Row>
              <Col md={6}>
                <DetailItem
                  label="Notice Period"
                  value={`${resignationPolicyDetails?.notice_period_days} days`}
                  tooltip="The number of days you need to serve before leaving the company."
                />
                <DetailItem
                  label="Salary Release"
                  value={`${resignationPolicyDetails?.salary_release_days} days ${resignationPolicyDetails?.salary_release_type_id}`}
                  tooltip="Salary will be released after the notice period is completed."
                />
                <DetailItem
                  label="Asset Return"
                  value={`${resignationPolicyDetails?.asset_return_days_before} days ${resignationPolicyDetails?.asset_return_type_id}`}
                  tooltip="Company assets must be returned before your last working day."
                />
              </Col>
              <Col md={6}>
                <DetailItem
                  label="Pending Amount Release"
                  value={`${resignationPolicyDetails?.pending_amount_release_days} days ${resignationPolicyDetails?.pending_amount_release_type_id}`}
                  tooltip="Any pending amounts will be released along with your salary."
                />
                <DetailItem
                  label="Document Release"
                  value={`${resignationPolicyDetails?.document_release_days} days ${resignationPolicyDetails?.document_release_type_id}`}
                  tooltip="Documents will be released after the notice period is completed."
                />
              </Col>
            </Row>
          </Card.Body>
        </Card> */}

        <Form onSubmit={(e) => e.preventDefault()}>
          <Form.Group className="mb-3">
            <Form.Label>Reason for Separation</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={resignationDetails?.reason_of_resignation}
              onChange={(e) => {
                onChangeReason(e);
              }}
            />
            {error.reason && (
              <span className="text-danger">* {error?.reason}</span>
            )}
          </Form.Group>
          <div className="d-flex gap-2">
            <Button
              variant="primary"
              className="ms-auto"
              onClick={handleSubmit}
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                  <span className="ms-2">Applying...</span>
                </>
              ) : (
                "Apply"
              )}
            </Button>
            <Button
              variant="danger"
              onClick={() => {
                resetValues();
                onHide();
              }}
              disabled={isSubmitting}
            >
              Cancel
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

const DetailItem = ({ label, value, tooltip }) => (
  <div className="mb-3">
    <strong>{label}: </strong>
    <span>{value}</span>
    <FaInfoCircle className="ms-2" title={tooltip} />
  </div>
);

export default ResignationModal;
